import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import SalesService from 'services/sales-service';
import { FetchStatus, ResultState, WithFilter } from 'types/common';
import { SalesFilter, SalesListItem } from 'types/sales';
import { SALES_FILTER_DEFAULT } from 'utils/constants/default-filters';
import { RootState } from './index';

const initialState: ResultState<SalesListItem[] | null> & WithFilter<SalesFilter> = {
	data: null,
	filter: SALES_FILTER_DEFAULT,
	status: FetchStatus.IDLE,
	error: null,
};

export const fetchSalesListAsync = createAsyncThunk(
	'sales/all',
	async (filter: SalesFilter) => {
		const response: SalesListItem[] = await SalesService.getSalesList(filter);

		return response;
	},
);

export const salesListSlice = createSlice({
	name: 'salesList',
	initialState,
	reducers: {
		resetSalesListData: () => initialState,
		setSalesListFilter: (state, { payload }: PayloadAction<SalesFilter>) => {
			state.filter = payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchSalesListAsync.pending, (state) => {
				state.status = FetchStatus.LOADING;
			})
			.addCase(fetchSalesListAsync.fulfilled, (state, action) => {
				state.status = FetchStatus.IDLE;
				state.data = action.payload;
			});
	},
});

const getSalesList = (state: RootState) => state.salesList;

export const { resetSalesListData, setSalesListFilter } = salesListSlice.actions;

export const getSalesListData = createSelector(getSalesList, salesList => salesList.data);
export const getSalesListFilter = createSelector(getSalesList, salesList => salesList.filter);

export default salesListSlice.reducer;
